import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { signOutUser } from '../../../services/authService';
import Button from '../UI/Button';

export default function TopBar({ pageTitle }) {
  const { userProfile } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOutUser();
    navigate('/login');
  }

  return (
    <header className="topbar">
      <span className="topbar-title">{pageTitle || 'Admin Portal'}</span>
      <div className="topbar-right">
        <span className="topbar-user">
          Signed in as <strong>{userProfile?.full_name || userProfile?.email || 'Admin'}</strong>
        </span>
        <Button variant="secondary" size="sm" onClick={handleSignOut}>Sign Out</Button>
      </div>
    </header>
  );
}
